import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";

const NAVBAR_H = 64; // px — must match your fixed top Navbar height

export default function AdminLayout({ children, unreadCount = 0 }) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 992 : false,
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener("resize", onResize, { passive: true });
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <div
      style={{
        minHeight: "100dvh",
        display: "grid",
        gridTemplateColumns: isMobile ? "minmax(0,1fr)" : "270px minmax(0,1fr)",
        background: "#eef2f7",
        overflow: "hidden",
      }}
    >
      {/* Desktop pinned sidebar */}
      {!isMobile && (
        <div
          style={{
            position: "sticky",
            top: NAVBAR_H,
            alignSelf: "start",
            height: `calc(100dvh - ${NAVBAR_H}px)`,
            overflowY: "auto",
            overflowX: "hidden",
            background: "#0f1d47",
          }}
        >
          <AdminSidebar unreadCount={unreadCount} />
        </div>
      )}

      {/* Main content */}
      <main
        style={{
          marginTop: NAVBAR_H,
          height: `calc(100dvh - ${NAVBAR_H}px)`,
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
          minHeight: 0,
          background: "#f8fafc",
          padding: 20,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            overflowX: "hidden",
            scrollbarGutter: "stable",
          }}
        >
          {children}
        </div>
      </main>

      {/* ✅ Mobile: mount sidebar but hide its FAB (header already has hamburger) */}
      {isMobile && (
        <div
          style={{
            position: "fixed",
            width: 0,
            height: 0,
            overflow: "hidden",
            pointerEvents: "none",
            zIndex: 0,
          }}
        >
          <AdminSidebar unreadCount={unreadCount} hideFab />
        </div>
      )}
    </div>
  );
}
